import {Component, Input, OnInit} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {environment} from '../../../environments/environment';
import {finalize, tap} from 'rxjs/operators';
import {GenericModalComponent} from '@shared/modals/generic-modal/generic-modal.component';
import {SubmissionService} from '../submission.service';
import {LookupModalComponent} from '../lookup-modal/lookup-modal.component';

@Component({
    selector: 'app-submission-inline',
    templateUrl: './submission-inline.component.html',
    styleUrls: ['./submission-inline.component.css'],
    standalone: false
})
export class SubmissionInlineComponent implements OnInit {
  @Input() items: any[];
  @Input() meta: any;
  @Input() hasPermission: boolean;
  @Input() loading: boolean;
  @Input() foreignKeyField: string;
  @Input() deleteText: string;
  @Input() nested: any;
  @Input() id: any;

  isCollapsed = true;
  loadingMore = false;

  constructor(public modal: NgbModal, public SubmissionService: SubmissionService, public http: HttpClient) {
  }

  ngOnInit(): void {
    if (this.meta && this.meta.searchParams) {
      this.meta.searchParams.page = 1;
    }
  }

  open(item: any = {}, event?: Event): void {
    if (event) {
      this.isCollapsed = false;
      event.stopPropagation();
    }
    // var item = {};
    item[this.foreignKeyField] = this.id;
    // }
    const modalInstance = this.modal.open(LookupModalComponent, {
      backdrop: 'static',
      size: 'md'

    });
    modalInstance.componentInstance.item = item;
    modalInstance.componentInstance.meta = this.meta;
    modalInstance.componentInstance.id = this.id;
    modalInstance.result.then(item => {
      this.SubmissionService.loadSubmission(this.SubmissionService.currentSubmission.globalid);
      // this would be nice to have but just load whole submission for now
      // if (item !== undefined) {
      //   this.items.forEach((thisItem, i) => {
      //     if (thisItem.globalid === item.globalid) {
      //       this.items.splice(i, 1);
      //     }
      //   });
      //   this.items.unshift(item);
      // }
    });
  }

  delete(item: any): void {
    this.meta.count--;
    const modalInstance = this.modal.open(GenericModalComponent, {
      backdrop: 'static',
      size: 'sm'
    });
    modalInstance.componentInstance.title = 'Delete';
    modalInstance.componentInstance.body = `Are you sure you want to delete this ${this.deleteText}?`;
    modalInstance.result.then(() => {

      var removeItem = {};
      removeItem[this.meta.type.slice(this.meta.type.indexOf('/') + 1, this.meta.type.length)] = item;
      this.SubmissionService.removeFromSubmission(removeItem)
    });
  }

  loadMore(): void {
    this.loadingMore = true;
    this.meta.searchParams.page++;
    this.http.get(this.meta.url, {
      params: this.meta.searchParams
    }).pipe(
      tap((response: any) => this.items = this.items.concat(response.results)),
      finalize(() => {
        this.loadingMore = false;
      })
    ).subscribe();
  }
}
